import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorkOrders(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDERS,
		options
	)
}

function _getWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER,
		options
	)
}

function _createWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_WORK_ORDER,
		options
	)
}

function _createFieldWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_FIELD_WORK_ORDER,
		options
	)
}

function _putWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_WORK_ORDER,
		options
	)
}

function _putCloseFieldWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_CLOSE_FIELD_WORK_ORDER,
		options
	)
}

function _putUpdateFieldWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_UPDATE_FIELD_WORK_ORDER,
		options
	)
}

function _patchWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_WORK_ORDER,
		options
	)
}

function _patchCloseFieldWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_CLOSE_FIELD_WORK_ORDER,
		options
	)
}

function _patchUpdateFieldWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_UPDATE_FIELD_WORK_ORDER,
		options
	)
}

function _deleteWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].DELETE_WORK_ORDER,
		options
	)
}

function _getWorkOrderPreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_PREVIEW,
		options
	)
}

function _getWorkOrderPopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_POPUP,
		options
	)
}

function _patchWorkOrderRecalculate(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_WORK_ORDER_RECALCULATE,
		options
	)
}

function _getWorkOrderIsCanBeClosed(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_IS_CAN_BE_CLOSED,
		options
	)
}

function _createLogisticWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_LOGISTIC_WORK_ORDER,
		options
	)
}

function _putCloseLogisticWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_CLOSE_LOGISTIC_WORK_ORDER,
		options
	)
}

function _putUpdateLogisticWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_UPDATE_LOGISTIC_WORK_ORDER,
		options
	)
}

function _patchCloseLogisticWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_CLOSE_LOGISTIC_WORK_ORDER,
		options
	)
}

function _patchUpdateLogisticWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_UPDATE_LOGISTIC_WORK_ORDER,
		options
	)
}

function _createHandMadeWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_HAND_MADE_WORK_ORDER,
		options
	)
}

function _patchHandMadeWorkOrder(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_HAND_MADE_WORK_ORDER,
		options
	)
}

function _copyToAnotherBrigade(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_BRIGADE,
		options
	)
}

function _copyToAnotherPeriod(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PERIOD,
		options
	)
}

function _copyToAnotherPlanWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.WORK_ORDERS,
		ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PLAN_WORK,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDERS]: _getWorkOrders,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER]: _getWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_WORK_ORDER]: _createWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_FIELD_WORK_ORDER]: _createFieldWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_WORK_ORDER]: _putWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_CLOSE_FIELD_WORK_ORDER]: _putCloseFieldWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_UPDATE_FIELD_WORK_ORDER]: _putUpdateFieldWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_WORK_ORDER]: _patchWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_CLOSE_FIELD_WORK_ORDER]: _patchCloseFieldWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_UPDATE_FIELD_WORK_ORDER]: _patchUpdateFieldWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].DELETE_WORK_ORDER]: _deleteWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_PREVIEW]: _getWorkOrderPreview,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_POPUP]: _getWorkOrderPopup,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_WORK_ORDER_RECALCULATE]: _patchWorkOrderRecalculate,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_IS_CAN_BE_CLOSED]: _getWorkOrderIsCanBeClosed,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_LOGISTIC_WORK_ORDER]: _createLogisticWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_CLOSE_LOGISTIC_WORK_ORDER]: _putCloseLogisticWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_UPDATE_LOGISTIC_WORK_ORDER]: _putUpdateLogisticWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_CLOSE_LOGISTIC_WORK_ORDER]: _patchCloseLogisticWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_UPDATE_LOGISTIC_WORK_ORDER]: _patchUpdateLogisticWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_HAND_MADE_WORK_ORDER]: _createHandMadeWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_HAND_MADE_WORK_ORDER]: _patchHandMadeWorkOrder,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_BRIGADE]: _copyToAnotherBrigade,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PERIOD]: _copyToAnotherPeriod,
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PLAN_WORK]: _copyToAnotherPlanWork,
}
